import { SmsCustomization } from '../../../api';

export type FormValues = {
  mfa_code: string;
  phone_auth_code: string;
  provided_language: string;
};

export type ExistFields = {
  mfa_code: boolean;
  phone_auth_code: boolean;
};

export type ExistState = {
  existsTemplates: ExistFields;
  setExistsTemplates: React.Dispatch<React.SetStateAction<ExistFields>>;
};

export type CustomizeTemplateProps = {
  projectId: string;
  existState: ExistState;
  values: FormValues;
  templateType: 'phone_auth_code' | 'mfa_code';
};

export type LanguagesType = string[];

export type SmsPreviewState = {
  smsCustomization: SmsCustomization;
  fetching: boolean;
  submitting: boolean;
  isPreview: boolean;
  submitError: boolean;
};

export enum ActionType {
  getSmsSuccess = 'getSmsSuccess',
  getSmsFail = 'getSmsFail',
  updateSms = 'updateSms',
  submitStarted = 'submitStarted',
  submitSuccess = 'submitSuccess',
  submitFailed = 'submitFailed'
}

export type Action =
  | { type: ActionType.getSmsSuccess; payload: SmsCustomization }
  | { type: ActionType.getSmsFail }
  | { type: ActionType.updateSms; payload: SmsCustomization }
  | { type: ActionType.submitStarted }
  | { type: ActionType.submitSuccess; payload: SmsCustomization }
  | { type: ActionType.submitFailed };
